import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useContactsStore } from '@/store/contacts';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/clients/contacts/contacts.config';
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const moduleName = 'Contacts';

export default /*@__PURE__*/_defineComponent({
  __name: 'Contacts',
  props: {
    clientId: {},
    client: {}
  },
  setup(__props: any) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const preferencesStore = usePreferencesStore();
const contactsStore = useContactsStore();

const props = __props;

const { clientId } = props;

const buildParams = (params: any) => {
  // Solo agrega el filtro si clientId está definido y es válido
  if (clientId !== undefined && clientId !== null) {
    return {
      ...params,
      'filter[client_id]': clientId,
    };
  }
  return params;
};

const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => contactsStore.fetchContacts(buildParams(params)),
  {
    create: contactsStore.createContact,
    update: (data) => contactsStore.updateContact(data.id, data),
    remove: contactsStore.deleteContact,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const rowActionHandlers = {
  
};

const data = computed(() => contactsStore.contacts);


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleName,
        listViewComponent: Table,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/clients/contacts/contacts.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        show_toolbar: true,
        show_pagination: true,
        title: {singular:'Contacto', plural:'Contactos'},
        rowActionHandlers: rowActionHandlers,
        key: moduleName,
        client: _ctx.client,
        clientId: _unref(clientId)
      }, null, 8, ["data", "onCreate", "onUpdate", "onDelete", "client", "clientId"]))
    ]),
    _: 1
  }))
}
}

})